// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"fbe5c26c","159":"fb816e9e"}[chunkId] + ".css";
};